<template>
  <form class="login-form" @submit.prevent="auth">
    <div class="card mb-0">
      <div class="card-body">
        <div class="text-center mb-3">
          <div
            class="d-inline-flex align-items-center justify-content-center my-2"
          >
            <img src="@/assets/img/logo.png" class="h-72px" alt="Logo" />
          </div>
          <h4 class="mb-1 text-success">Sistema de Gestão Orçamentária</h4>
        </div>
        <div class="mb-3">
          <label class="form-label">Usuário</label>
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="text"
              class="form-control"
              :class="{ 'is-invalid': v$.codUsuario.$errors.length }"
              placeholder="Usuário do TOTVS RM"
              v-model="v$.codUsuario.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph-user text-muted" />
            </div>
            <span
              v-if="v$.codUsuario.required.$invalid"
              class="invalid-feedback"
            >
              O campo é obrigatório
            </span>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Senha</label>
          <div class="form-control-feedback form-control-feedback-start">
            <input
              type="password"
              class="form-control"
              :class="{ 'is-invalid': v$.password.$errors.length }"
              placeholder="•••••••••••"
              v-model="v$.password.$model"
            />
            <div class="form-control-feedback-icon">
              <i class="ph-lock text-muted" />
            </div>
            <span v-if="v$.password.required.$invalid" class="invalid-feedback">
              O campo é obrigatório
            </span>
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Coligada</label>
          <select class="form-select" v-model="v$.codColigada.$model">
            <option value="" disabled>Selecione uma Coligada</option>
            <option
              v-for="empresa in empresas"
              :key="empresa.codColigada"
              :value="empresa.codColigada"
              :title="`${empresa.codColigada} - ${empresa.nome}`"
            >
              {{ empresa.codColigada }} - {{ empresa.nome }}
            </option>
          </select>
          <span
            v-if="v$.codColigada.required.$invalid"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
        <div class="mb-2">
          <button
            type="submit"
            class="btn btn-success w-100"
            title="Login"
            :disabled="v$.$invalid || disableButton"
          >
            <span v-if="disableButton">
              <i class="ph-spinner spinner" />
            </span>
            <span v-else>Login</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import PATHS from '@/router/routesMap'

export default {
  name: 'Auth',

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      empresas: [],
      codUsuario: '',
      password: '',
      codColigada: '',
      disableButton: false,
    }
  },

  methods: {
    async getEmpresas() {
      try {
        this.empresas = await this.$store.dispatch('getEmpresas')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async auth() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          await this.$store.dispatch('auth', {
            codUsuario: this.codUsuario,
            password: this.password,
            codColigada: this.codColigada,
          })
          this.disableButton = false
          this.$router.push(PATHS.HOME)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      codUsuario: {
        required,
      },
      password: {
        required,
      },
      codColigada: {
        required,
      },
    }
  },

  mounted() {
    if (localStorage.getItem('sessionError')) {
      this.$root.$refs.notification.warning(
        localStorage.getItem('sessionError'),
      )
      localStorage.removeItem('sessionError')
    }
    this.getEmpresas()
  },
}
</script>
